import React from 'react'
import { Routes, Route } from 'react-router'
import { Provider } from 'react-redux'
import { BoardDetails } from './pages/board-details'
import LandingPage from './pages/landing-page'
import ServicesPage from './pages/services-page'
import AboutPage from './pages/about-page'
import ContactPage from './pages/contact-page'
import HowItWorksPage from './pages/how-it-works-page'
import QuickRequestPage from './pages/quick-request-page'
import BoardGridPage from './pages/board-grid-page'
import { LoginSignup } from './pages/login-signup'
import { store } from './store/store'

export function RootCmp () {
    return (
        <Provider store={store}>
            <div>
                <main>
                    <Routes>
                        <Route element={<LandingPage />} path='/' />
                        <Route element={<ServicesPage />} path='/services' />
                        <Route element={<AboutPage />} path='/about' />
                        <Route element={<ContactPage />} path='/contact' />
                        <Route element={<HowItWorksPage />} path='/how-it-works' />
                        <Route element={<QuickRequestPage />} path='/quick-request' />
                        <Route element={<BoardGridPage />} path='/boards' />
                        <Route element={<BoardDetails />} path='/board/:boardId/' />
                        <Route element={<BoardDetails />} path='/board/:boardId/:groupId/:taskId' />
                        <Route element={<BoardDetails />} path='/board/:boardId/:activityLog' />
                        <Route element={<LoginSignup />} path='/auth/login' />
                        <Route element={<LoginSignup />} path='/auth/signup' />
                    </Routes>
                </main>
            </div>
        </Provider>
    )
}
